// Angular
import { Pipe, PipeTransform } from '@angular/core';
import { IFileModel } from '../interfaces/file-model.interface';

/**
 * Sanitize HTML
 */
@Pipe({
  name: 'blobToImage',
})
export class BlobToImagePipe implements PipeTransform {
  /**
   * Transform
   *
   * @param value: string
   */
  transform(value: string): string {
    try {
      const [image] = JSON.parse(value || `[]`) as IFileModel[];
      return image?.BlobUrl || '';
    } catch (error) {
      console.error('error while parsing image blog url', error);
    }

    return '';
  }
}
